import { atom } from 'recoil';
import defaultGroups from 'ProjectManager/Template/List/recoil/groups/defaultGroups';

const groupsAtom = atom({
    key: 'projectManager_templateGroupsList',
    default: defaultGroups,
});

export default groupsAtom;
